import TopicsFooter from './TopicsFooter';

export default TopicsFooter;
